export const SOLANA_RPC_POOL_URL: string = process.env.REACT_APP_SOLANA_RPC_HOST || "";

export const DISCORD_LINK: string = "https://discord.com/invite/9c7JSDBuDd";
export const TWITTER_LINK: string = "https://twitter.com/VibingApes1";
//Others
export const THEME_MODE: string = "theme";

export const BLOCKCHAIN_NETWORK: string = "13knf0234";
export const LOGIN_TOKEN: string = "08U23ORKNMFW823";
